import api from '../api'

export interface JobResult {
  status: 'pending' | 'processing' | 'completed' | 'failed'
  midiJson?: string
  clip?: any
  error?: string
  promptText?: string
  inputTokens?: number
  outputTokens?: number
  aiModel?: string
  aiThinking?: boolean
}

export async function pollJob(jobId: string, token: string, intervalMs = 3000, maxAttempts = 100): Promise<JobResult> {
  for (let i = 0; i < maxAttempts; i++) {
    await new Promise(resolve => setTimeout(resolve, intervalMs))

    const response = await api.get(`/songs/jobs/${jobId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })

    const data = response.data as JobResult
    if (data.status === 'completed') return data
    if (data.status === 'failed') {
      const err = new Error(data.error || 'Generation failed') as Error & { promptText?: string }
      err.promptText = data.promptText
      throw err
    }
  }

  throw new Error('Generation timed out')
}
